import { i18n } from '../../translate/i18n'
import { detect, Browser, detectOS } from 'detect-browser'
import { Chains } from 'context/Chain'
import { ConfigurationOptions } from 'typesense/lib/Typesense/Configuration'

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'

export const __DEV__ =
  !process.env.NODE_ENV || process.env.NODE_ENV === 'development'

export const CVM_EMAIL = 'business@onepercent.io'

export const DELIVERY_TYPE = {
  TRANSFER: 0,
  MINT: 1,
  PACK: 2,
}

export const IS_PRODUCTION = process.env.REACT_APP_PRODUCTION === 'true'

export const CONTACT_US: {
  portalId: string
  formId: string
} =
  process.env.REACT_APP_CONTACT_FORM_CONFIG &&
  JSON.parse(process.env.REACT_APP_CONTACT_FORM_CONFIG)

export const METAMAP_CONFIG: {
  clientId: string
  flowId: string
} =
  process.env.REACT_APP_METAMAP_CONFIG &&
  JSON.parse(process.env.REACT_APP_METAMAP_CONFIG)

export const REACT_APP_STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY!
export const REACT_APP_COINBASE_ORIGIN = process.env.REACT_APP_COINBASE_ORIGIN!

export const PRODUCTION = process.env.REACT_APP_PRODUCTION === 'true'

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY

export const LS_REDIRECT_URI = 'redirect_uri'

export const LS_PENDING_CREDENTIAL = 'pending_credential'

export const PACK_TYPE = 'pack'
export const SINGLE_TYPE = 'single'

export const FIREBASE_CONFIG = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG!)

export const RARUM_DESCRIPTION = i18n.t('core.constants.rarumDescription', {
  returnObjects: true,
}) as unknown as String[]

export const DATA_DELETION_INSTRUCTIONS = i18n.t(
  'core.constants.dataDeletionInstructions',
  { returnObjects: true }
) as unknown as String[]

export const EXTERNAL_ENVIRONMENT_ALERT = i18n.t(
  'core.constants.externalEnvironmentAlert'
)

export const BROWSER = detect()!.name as Browser

export const chainConfig: { [key in Chains]: ChainConfig } = process.env
  .AUTOMATION
  ? (new Proxy(
      {},
      {
        get(_, key) {
          return (window._chainConfig as any)[key]
        },
      }
    ) as any)
  : IS_PRODUCTION
  ? {
      POLYGON: {
        id: Number('0x89'),
        name: 'Polygon',
        currency: 'MATIC',
        explorerUrl: 'https://polygonscan.com/address',
        explorerName: 'Polygonscan',
        providerAddress:
          'https://polygon-mainnet.g.alchemy.com/v2/j9KdggulLkgyCeXevvkBnNYb6auVu01v',
        rpcUrl: 'https://polygon-rpc.com',
        stableTokens: [
          {
            symbol: 'USDC',
            address: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
            decimals: 6,
          },
          {
            symbol: 'BRLA',
            address: '0xE6A537a407488807F0bbeb0038B79004f19DDDFb',
            decimals: 6,
          },
        ],
        gasFeeEndpoint: 'https://gasstation.polygon.technology/v2',
      },
      MOONBEAM: {
        id: Number('0x504'),
        name: 'Moonbeam',
        currency: 'GLMR',
        explorerUrl: 'https://moonscan.io/address',
        explorerName: 'Moonbase',
        providerAddress: 'https://1rpc.io/2q16bQSq6pmNvR7pd/glmr',
        rpcUrl: 'https://rpc.moonbeam.network',
        stableTokens: [],
        gasFeeEndpoint: undefined,
      },
      ETHEREUM: null as any,
    }
  : {
      POLYGON: {
        id: Number('0x13882'),
        name: 'Amoy',
        currency: 'MATIC',
        explorerUrl: 'https://amoy.polygonscan.com/address',
        explorerName: 'Polygonscan',
        providerAddress:
          'https://polygon-amoy.g.alchemy.com/v2/j9KdggulLkgyCeXevvkBnNYb6auVu01v',
        rpcUrl: 'https://rpc-amoy.polygon.technology',
        stableTokens: [
          {
            symbol: 'USDC',
            address: '0x3b9ae540E886871d111F9a494165579dC99D22Bb',
            decimals: 18,
          },
          {
            symbol: 'BRLA',
            address: '0x8b649099F4e3F5c5C032eeA961AB85048C1C4509',
            decimals: 6,
          },
        ],
        gasFeeEndpoint: 'https://gasstation-testnet.polygon.technology/v2',
      },
      MOONBEAM: {
        id: Number('0x507'),
        name: 'Moonbase',
        currency: 'DEV',
        explorerUrl: 'https://moonbase.moonscan.io/address',
        explorerName: 'Moonbase',
        providerAddress: 'https://rpc.testnet.moonbeam.network',
        rpcUrl: 'https://rpc.testnet.moonbeam.network',
        stableTokens: [],
        gasFeeEndpoint: undefined,
      },
      ETHEREUM: {
        id: Number('0xaa36a7'),
        name: 'Sepolia',
        currency: 'ETH',
        explorerUrl: 'https://sepolia.etherscan.io/address',
        explorerName: 'Etherscan',
        providerAddress:
          'https://eth-sepolia.g.alchemy.com/v2/x9WRmpIz0BhGayr3su79N_jRP_PYAsQO',
        rpcUrl: 'https://eth-sepolia.g.alchemy.com',
        stableTokens: [
          {
            address: '0x0D0f2A1597aFaB9A2f0096165b4a20Ac8356Fd66',
            decimals: 18,
            symbol: 'BRLA',
          },
        ],
        gasFeeEndpoint: undefined,
        escrowAddress: '0x128AB8A2B944c645b46166e121f646c3B7B228f8',
      },
    }

export type Stable = {
  symbol: CryptoCurrencySymbol
  address: string
  decimals: number
}

export type ChainConfig = {
  id: number
  name: string
  currency: string
  explorerUrl: string
  explorerName: string
  providerAddress: string
  rpcUrl: string
  stableTokens: Stable[]
  gasFeeEndpoint: string | undefined
  escrowAddress: string
}

export const UF = [
  { nome: 'Acre', sigla: 'AC' },
  { nome: 'Alagoas', sigla: 'AL' },
  { nome: 'Amapá', sigla: 'AP' },
  { nome: 'Amazonas', sigla: 'AM' },
  { nome: 'Bahia', sigla: 'BA' },
  { nome: 'Ceará', sigla: 'CE' },
  { nome: 'Distrito Federal', sigla: 'DF' },
  { nome: 'Espírito Santo', sigla: 'ES' },
  { nome: 'Goiás', sigla: 'GO' },
  { nome: 'Maranhão', sigla: 'MA' },
  { nome: 'Mato Grosso', sigla: 'MT' },
  { nome: 'Mato Grosso do Sul', sigla: 'MS' },
  { nome: 'Minas Gerais', sigla: 'MG' },
  { nome: 'Pará', sigla: 'PA' },
  { nome: 'Paraíba', sigla: 'PB' },
  { nome: 'Paraná', sigla: 'PR' },
  { nome: 'Pernambuco', sigla: 'PE' },
  { nome: 'Piauí', sigla: 'PI' },
  { nome: 'Rio de Janeiro', sigla: 'RJ' },
  { nome: 'Rio Grande do Norte', sigla: 'RN' },
  { nome: 'Rio Grande do Sul', sigla: 'RS' },
  { nome: 'Rondônia', sigla: 'RO' },
  { nome: 'Roraima', sigla: 'RR' },
  { nome: 'Santa Catarina', sigla: 'SC' },
  { nome: 'São Paulo', sigla: 'SP' },
  { nome: 'Sergipe', sigla: 'SE' },
  { nome: 'Tocantins', sigla: 'TO' },
]

export const SHARE_FACEBOOK_APP_ID = '485160149428159'
export const SHARE_TITLE = i18n.t('core.constants.shareTitle')
export const SHARE_URL = 'https://rarum.io'
export const SHARE_TEXT = i18n.t('core.constants.shareText')
export const RARUM_NAME = 'Rarum'

export { ERC20ABI } from './ERC20ABI'
export { ERC1155ABI } from './ERC1155ABI'
export { RARUMSALESABI, RAW_RARUMSALESABI } from './RARUMSALESABI'

export const RARITIES = ['COMMON', 'RARE', 'EPIC', 'LEGENDARY'] as const
export const SIGNATURE_TTL_SECONDS = 3600
export const SOCIAL_LINKS = {
  instagram: {
    title: 'Instagram',
    link: 'https://www.instagram.com/onepercentio',
  },
  linkedin: {
    title: 'LinkedIn',
    link: 'https://www.linkedin.com/company/onepercentio',
  },
  twitter: {
    title: 'Twitter',
    link: 'https://twitter.com/OnePercentIO',
  },
}
export const PLATFORM = (() => {
  const os = detectOS(window.navigator.userAgent)!
  if (os.toLowerCase().includes('windows')) return 'windows'
  if (os.toLowerCase().includes('linux')) return 'linux'
  else return os
})()
export const TypeSenseConfig: ConfigurationOptions = process.env.AUTOMATION
  ? {
      nodes: [
        {
          host: 'localhost', // For Typesense Cloud use xxx.a1.typesense.net
          port: '8108', // For Typesense Cloud use 443
          protocol: 'http', // For Typesense Cloud use https
        },
      ],
      apiKey: 'typesense-key',
      connectionTimeoutSeconds: 2,
    }
  : IS_PRODUCTION
  ? ({} as any)
  : ({} as any)
